import { render, staticRenderFns } from "./search-source.vue?vue&type=template&id=44aaa96e&scoped=true&"
import script from "./search-source.vue?vue&type=script&lang=ts&"
export * from "./search-source.vue?vue&type=script&lang=ts&"
import style0 from "./search-source.vue?vue&type=style&index=0&id=44aaa96e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44aaa96e",
  null
  
)

export default component.exports